import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=365e670a&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=365e670a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e670a",
  null
  
)

export default component.exports